import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@mui/material';

import { TextField } from '@components/base';
import useSuggestAsYouType from '@hooks/useSuggestAsYouType';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';

type FilterAutocompleteFieldProps = {
  fieldName: string;
  setValue: (value: string) => void;
  value?: string;
};

const FilterAutocompleteField: FC<FilterAutocompleteFieldProps> = ({
  fieldName,
  value,
  setValue,
}) => {
  const { t } = useTranslation();
  const { isReadonly } = useSearchAndFilter();

  const [focus, setFocus] = useState(false);

  const { loading, suggestions } = useSuggestAsYouType(String(value), {
    fieldName,
    disabled: !focus,
  });

  return (
    <Autocomplete
      disableClearable
      disabled={isReadonly}
      disablePortal
      freeSolo
      loading={loading}
      onBlur={() => setFocus(false)}
      onChange={(_, val) => setValue(val || '')}
      onFocus={() => setFocus(true)}
      options={suggestions}
      renderInput={props => (
        <TextField
          {...props}
          label={t('value')}
          onChange={({ currentTarget: { value } }) => setValue(value)}
          value={value}
        />
      )}
      value={value}
    />
  );
};

export default FilterAutocompleteField;
